import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/general';
const DARK_THEME_PATH = 'icons/darkTheme/general';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const ReputationInsufficientSalesIcon = {
  alt: 'Vendas insuficientes para avaliar',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
};

export const EmptyCart = {
  alt: 'Carrinho Vazio',
  light: {
    src: icon(LIGHT_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
};

export const ExtractIcon = {
  alt: 'Carteira Vazia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
};
